<template>
  <div>
    <template v-if="value">
      <b-alert
        :show="'dismiss' in value ? value.dismiss : 5"
        dismissible
        fade
        @dismissed="disable()"
        :variant="value ? value.variant : ''"
        >{{ value ? value.text : "" }}</b-alert
      >
    </template>
  </div>
</template>

<script>
export default {
  name: "Notification",
  props: ["value"],
  methods: {
    disable: function() {
      this.$emit("input", null);
    }
  }
};
</script>

<style scoped></style>
